<div class="container">
    <mat-radio-group (change)="valueChanged($event)" *ngIf="options.length">
        <div class="option" *ngFor="let option of options">
            <app-radio-button-group [singular]="true" [label]="option.label" [value]="option.value" [checked]="model == option.value" [disabled]="readonly"></app-radio-button-group>
        </div>
    </mat-radio-group>
</div>